import { AnimatePresence, motion } from 'framer-motion';
import React, { FC } from 'react';
import { BiX } from 'react-icons/bi';

import { ISourceDocuments } from '@/components/ZAIChatLayout/ChatMessages';
import BookCard from '@/components/ZAIChatLayout/SourceDrawer/BookCard';

interface Props {
  onClose?:
    | ((
        e: React.MouseEvent<Element, MouseEvent> | React.KeyboardEvent<Element>,
      ) => void)
    | undefined;
  open?: boolean | undefined;
  sourceDocumentsToDisplay: ISourceDocuments[];
}

const Sources: FC<Props> = ({ onClose, open, sourceDocumentsToDisplay }) => {
  return (
    <AnimatePresence>
      {open ? (
        <motion.div
          layout
          initial={{ width: 0, opacity: 0 }}
          animate={{ width: 348, opacity: 1 }}
          exit={{ width: 0, opacity: 0 }}
          transition={{
            width: { duration: 0.3, ease: 'easeInOut' },
            opacity: { duration: 0.2 },
          }}
          className='bg-grayZl-925 border-l border-grayZl-900 flex'
        >
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ delay: 0.3, duration: 0.15 }}
            className='flex flex-col flex-1'
          >
            <div className='flex items-center justify-between p-[18px] border-b border-grayZl-900'>
              <p className='text-xl text-white font-medium leading-7'>
                Sources
              </p>
              <BiX onClick={onClose} className='h-7 w-7' />
            </div>

            <div className='py-[18px] flex flex-col gap-[18px] zai-scrollbar overflow-auto flex-1'>
              {sourceDocumentsToDisplay?.map((sourceDocument) => (
                <BookCard
                  sourceDocument={sourceDocument}
                  key={sourceDocument.citation_id}
                />
              ))}
            </div>
          </motion.div>
        </motion.div>
      ) : null}
    </AnimatePresence>
  );
};

export default Sources;
